import { render, staticRenderFns } from "./OutcomeSelection.vue?vue&type=template&id=6bd9c4f2&scoped=true"
import script from "./OutcomeSelection.vue?vue&type=script&lang=js"
export * from "./OutcomeSelection.vue?vue&type=script&lang=js"
import style0 from "./OutcomeSelection.vue?vue&type=style&index=0&id=6bd9c4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9c4f2",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QImg});qInstall(component, 'directives', {Ripple});
